// extracted by mini-css-extract-plugin
module.exports = {"root":"layout-content_root__EmY0o","header":"layout-content_header__3CRwl","separator":"layout-content_separator__2C63l","main":"layout-content_main__2NJFX"};